export function readCollectionFieldNames(value: unknown): string[] {
  if (!Array.isArray(value)) return [];

  return value
    .map((item) => {
      if (item && typeof item === 'object' && !Array.isArray(item)) {
        return (item as Record<string, unknown>).name;
      }

      return item;
    })
    .filter((item): item is string => typeof item === 'string' && item.length > 0);
}

export function isValidDateString(value: unknown): value is string {
  if (typeof value !== 'string' || value.trim().length === 0) return false;
  return !Number.isNaN(new Date(value).getTime());
}

export const collectionCardMetaTextClass = 'text-sm font-semibold leading-normal';

export const collectionCardMetaLabelClass =
  'text-sm font-medium leading-normal uppercase tracking-[0.08em]';

export const collectionCardBadgeTextClass = 'text-sm font-medium leading-normal';
